<div class="widget-filters widget" [ngClass]="{
    'widget-filters--offcanvas--always': offcanvas === 'always',
    'widget-filters--offcanvas--mobile': offcanvas === 'mobile'
}" appCollapse>
    <ng-container *ngIf="categoryData">
        <h4 class="widget-filters__title">{{"categories"|translate}}</h4>
        <div class="widget-filters__list">
            <div class="widget-filters__item">
                <div class="filter filter--opened" appCollapseItem="filter--opened">
                    <div class="filter__body" appCollapseContent>
                        <div class="filter__container">
                            <ul class="filter-categories__list">
                                <ng-container >
                                    <li class="list-item" *ngIf="currentCategory">
                                        <a [routerLink]="['./']">
                                            <app-icon class="filter-categories__arrow" name="arrow-rounded-left-6x9" size="6x9">
                                            </app-icon>  {{"all_categories"|translate}}
                                        </a>
                                    </li>
                                    <li *ngFor="let category of categoryData" class="list-item" [ngClass]="{'active' : currentCategory == category?.seo?.slug}">
                                        <a [routerLink]="['./']" [queryParams]="{category: category?.seo?.slug}">
                                            <app-icon class="filter-categories__arrow" name="arrow-rounded-left-6x9" size="6x9">
                                            </app-icon>  {{ translateHelper.localize(category?.name) }}
                                        </a>
                                    </li>
                                </ng-container>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
